import { gql } from "@/__generated__/gql";

export const DATA_MANAGEMENT_FILES_QUERY = gql(`
  query DataManagementFiles(
    $orgId: ID!
    $first: Int
    $after: String
    $before: String
    $ordering: [DataManagementFileOrderingInput!]
  ) {
    node(id: $orgId) {
      id
      ... on Organization {
        dataManagementFiles(
          first: $first
          after: $after
          before: $before
          ordering: $ordering
        ) {
          edges {
            node {
              id
              name
              url
              createdAt
            }
            cursor
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          totalCount
        }
      }
    }
  }
`);
